import {Injectable} from '@angular/core';
import * as Cookies from 'js-cookie';
import {ConstantsService} from '../constants/constants.service';
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class RegionService {
  constructor(
  ) {}

  getRegion() {
    return environment.use_global_id ? Cookies.get(ConstantsService.API_REGION_TOKEN) : Cookies.get(ConstantsService.DEPRECATED_API_REGION_TOKEN);
  }

  getRegionalUrl(url: string, region?: string) {
    if (!region) region = this.getRegion();

    if (region && region != 'au') {
      const api = url.slice(0, url.indexOf('.'));
      const domain = url.slice(url.indexOf('.') + 1);

      return `${api}-${region}.${domain}`;
    } else {
      return url;
    }
  }
}
